import '.d{display:flex;}.ssr-plugin'
import '.ac{flex-direction:row;}.ssr-plugin'
import '.ad{background-color:var(--palette-white);}.ssr-plugin'
import '.b5{flex-grow:1;}.ssr-plugin'
import '.a7{align-items:center;}.ssr-plugin'
import '.a8{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.dw{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.t{align-items:stretch;}.ssr-plugin'
import '.dx{margin-top:2rem;}.ssr-plugin'
import '.s{margin-bottom:5rem;}.ssr-plugin'
import '.ak{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { InitiativeSideBar } from '@app/components/blocks/sidebar/InitiativeSideBar'
import { ClientOnly } from '@based/sdk/react'

export const InitiativeViewPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <div className="d ac ad"
      >
        <InitiativeSideBar />
        <div className="b5 d a7 a8 e"
          style={{
            marginLeft: isMobile ? '3.25rem' : '14rem', // left bar
          }}
        >
          <DashboardNavBar
            initiativeDashboard={true}
            style={{ backgroundColor: 'var(--palette-white)' }}
          />
          <div className="dw d e t dx s ak"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '60%', // 12rem is padding + navbar height
              paddingInline: isMobile ? '1rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
